module.exports = __webpack_public_path__ + "img/20230710163055.d3f3ea64.png";